<!-- 多条件tab页签 -->
<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :title="title"
    inline-message
    width="1000px"
  >
    <el-tabs
      v-model="activeTabName"
      type="card"
      style="width:100%;"
    >
      <el-tab-pane
        v-for="(item, index) in lists"
        :key="index"
        :label="i18nAdvSearch('' + item.itemLabel)"
        :name="item.itemName"
      >
        <cargo-multi-condition-detail :read-only="readonly" :select-type="item.selectType" :params="item" :row-data="dataList[item.itemName]" :not-empty.sync="notEmpty[item.itemName]" />
      </el-tab-pane>
    </el-tabs>
    <div slot="footer">
      <span style="padding-right: 5px;">
        <!--确定/取消-->
        <el-button :disabled="readonly" type="primary" @click="submit">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import CargoMultiConditionDetail
  from '@/components/Cargo/Common/cargoMultiConditionDetail'
import { getGlobalQueryConfig } from '@/api/commonComponent'
import { deepClone } from '@/utils'

export default {
  name: 'CargoMultiConditionTab',
  components: { CargoMultiConditionDetail },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    detailValue: { type: String, default: '' },
    title: { type: String, default: '' },
    configModule: { type: String, default: '' }
  },
  data() {
    return {
      activeTabName: '',
      lists: [],
      dataList: {},
      notEmpty: {}
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.dataList = deepClone(this.detailValue ? JSON.parse(this.detailValue) : {})
      getGlobalQueryConfig(1, this.configModule).then((res) => {
        const result = res.data.configContent
        const list = JSON.parse(result)
        this.lists = list
        this.initData(list)
        this.activeTabName = list[0].itemName
      })
    },
    i18nAdvSearch(key) {
      const name = `${key}`
      const value = this.$t(`${key}`)
      if (value === name) {
        return key
      }
      return value
    },
    submit() {
      this.dataList.notEmpty = []
      for (const key in this.notEmpty) {
        if (this.notEmpty[key]) {
          this.dataList.notEmpty.push(key)
        }
      }
      this.$emit('change', JSON.stringify(this.dataList))
    },
    initData(staticData) {
      this.notEmpty = {}
      if (this.dataList.notEmpty) {
        for (const itemName of this.dataList.notEmpty) {
          this.notEmpty[itemName] = true
        }
      }
      for (const { itemName } of staticData) {
        this.loadData(itemName)
        if (this.dataList[itemName] && this.dataList[itemName].length > 0) {
          this.notEmpty[itemName] = true
        } else {
          if (!this.notEmpty.hasOwnProperty(itemName)) {
            this.notEmpty[itemName] = false
          }
        }
      }
    },
    loadData(key) {
      if (!this.dataList.hasOwnProperty(key)) {
        const data = []
        this.dataList[key] = data
        return data
      }
      return this.dataList[key]
    }
  }
}
</script>
